import { useState } from "react";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import CheckIcon from "@mui/icons-material/Check";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff1f2",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: 8,
  },
}));

const customIconStyling = ({ disabled }) => ({
  width: "24px",
  cursor: "pointer",
  color: disabled ? "#1D1B201A" : "#171717",
  rotate: "180deg",
});

const ADSInputCopy = ({ text, disabled }) => {
  const [tooltipText, setTooltipText] = useState("Copy To Clipboard");
  const [showCheckedIcon, setShowCheckedIcon] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setTooltipText("Copied To Clipboard");
      setShowCheckedIcon(true);

      setTimeout(() => {
        setShowCheckedIcon(false);
        setTooltipText("Copy To Clipboard");
      }, 1000);
    });
  };

  return (
    <LightTooltip title={tooltipText}>
      {showCheckedIcon ? (
        <CheckIcon sx={() => customIconStyling({ disabled })} />
      ) : (
        <ContentCopyRoundedIcon
          color="disabled"
          onClick={handleCopy}
          sx={() => customIconStyling({ disabled })}
        />
      )}
    </LightTooltip>
  );
};

export default ADSInputCopy;
